<template>
  <div>
    <div ref="captcha" />
  </div>
</template>

<script>
import { googleCaptcha } from '@/modules/user-cabinet/recommender-page/utils/captcha.js';

export default {
  name: 'Captcha',
  emits: ['onTokenResponse'],
  props: {
    config: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isRendered: false,
    };
  },
  watch: {
    'config.isEnabled': function (isEnabled) {
      if (!isEnabled) {
        return;
      }
      console.log('enabling captcha');
      const captchaService = googleCaptcha(this.config.sitekey, this.isRendered);

      captchaService.challenge(this.$refs.captcha, (captchaToken) => {
        console.log('log captchaToken: ', captchaToken);
        this.$emit('onTokenResponse', captchaToken);
        this.isRendered = true;

        if (window.CAPTCHA_CALLBACK) {
          window.CAPTCHA_CALLBACK();
        }
      });
    },
  },
};
</script>
